<template>
    <div class="controls controls-driving">
        <button type="button" class="controls__btn controls__action" v-for="min in minutes" :key="min" :disabled="setDisabled(min)" @click="setTimezone(min)" :class="setActive(min)">
            {{min}}
        </button>
        <popupDrivingTimeZone @activateControl="setControl" :minutes="driveTime" :id="id"/>
    </div>
</template>

<script>
    import popupDrivingTimeZone from './popupDrivingTimeZone'
    export default {
        props: ['id', 'time'],
        components: {
            popupDrivingTimeZone
        },
        data() {
            return {
                driveTime: this.time,
                minutes: [5, 10, 15],
                controlIsActive: false
            }
        },
        methods: {
            setTimezone(min) {
                this.driveTime = min;
                this.updateLocation(min)
            },
            setControl(state) {
              this.controlIsActive = state
            },
            updateLocation(min) {
                this.$store.dispatch('updateLocation', {id: this.id, driving_time_zone_minutes: min, setRadius: false, update: true})
                if(this.controlIsActive) {
                    this.$store.dispatch('fetchDrivingZone', {
                        id: this.id,
                        minutes: this.driveTime
                    })
                }
            },
            setActive(min) {
                if(this.driveTime === min) return 'is-active'
                else return;
            },
            setDisabled(min) {
                let disabled = this.driveTime === min
                return disabled ? true : false
            }
        },
    }
</script>
<style lang="sass" scoped>
    .controls__action
        &:disabled
            background: none
</style>
